import Icon from '@/components/Icon/Icon';
import { cn } from '@/lib/cn';

type LoaderVariant = 'default' | 'current';

interface LoaderProps {
  size?: string;
  className?: string;
  /** ローダーの色のバリエーション
   * - default: 半透明の黒 (stroke-black/50)
   * - current: 親要素の文字色 (stroke-current)
   */
  variant?: LoaderVariant;
}

const getLoaderStyles = (variant: LoaderVariant = 'default') => {
  const variantStyles: Record<LoaderVariant, string> = {
    default: 'stroke-black/50',
    current: 'stroke-current',
  };

  return variantStyles[variant];
};

export const Loader = ({
  size = 'size-10',
  className,
  variant = 'default',
}: LoaderProps) => (
  <Icon
    iconName="LoaderCircleIcon"
    className={cn(
      size,
      'animate-spin will-change-transform',
      getLoaderStyles(variant),
      className,
    )}
  />
);

export type { LoaderProps, LoaderVariant };
